import axios, { axiosNT } from '../../../services/axios';
import { MiniLibraryBody } from '../types/MiniLibraryBody';
import MiniLibraryDetail from '../types/MiniLibraryDetails';

const count = () => axiosNT.get('/miniLibrary/count')
    .then((res: any) => Promise.resolve(res.responseObject.count));

const list = () => axiosNT.get('/miniLibrary/')
    .then((res: any) => {
        let miniLibraries: MiniLibraryBody[] = res.responseObject;
        return Promise.resolve(miniLibraries);
    });

const create = (postData: MiniLibraryBody) => axios.post('/miniLibrary/', postData)
    .then((res: any) => {
        let miniLibrary: MiniLibraryBody = res.responseObject;
        return Promise.resolve(miniLibrary);
    });

const update = (postData: MiniLibraryBody, updateId: string) => axios.put(`/miniLibrary/${updateId}`, postData)
    .then((res: any) => {
        let miniLibrary: MiniLibraryBody = res.responseObject;
        return Promise.resolve(miniLibrary);
    });

const remove = (deleteId: string, deleteName: string) => axios.delete(`/miniLibrary/${deleteId}/${deleteName}`)
    .then((res: any) => {
        let miniLibrary: MiniLibraryBody = res.responseObject;
        return Promise.resolve(miniLibrary);
    });

const miniLibraryDetails = (reqBody: any) => axiosNT.post(`/miniLibrary/miniLibraryDetail`, reqBody)
    .then((res: any) => {
        let data: MiniLibraryDetail = res.responseObject;
        return Promise.resolve(data);
    })

export default {
    count,
    list,
    create,
    update,
    remove,
    miniLibraryDetails
}